import type { Locale } from './types';

/** Always shown in the language picker (native orthography). */
export const LOCALE_NATIVE_LABELS: Record<Locale, string> = {
  en: 'English',
  uk: 'Українська',
};
